export function isValidEmail(email) {
  return !!(email && email.match(/^[^@;]+@([^@.;]+\.)+[a-zA-Z]{2,20}$/))
}
